import { inject, Injectable, isDevMode } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, map } from 'rxjs/operators';

import { DialogService } from '../dialog/dialog.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceWorkerService {
  private readonly swUpdate: SwUpdate = inject(SwUpdate);
  public dialogService: DialogService = inject(DialogService);

  constructor() {
    this.initListener();
  }

  public initListener(): void {
    if (!isDevMode() && navigator.serviceWorker) {
      this.swUpdate.versionUpdates
        .pipe(
          filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
          map((evt: VersionReadyEvent) => {
            return {
              type: 'UPDATE_AVAILABLE',
              current: evt.currentVersion,
              available: evt.latestVersion
            };
          })
        )
        .subscribe(() => {
          this.showModal();
        });
    }
  }

  private showModal(): void {
    this.dialogService.showDialog({
      buttonText: 'Aktualisieren',
      title: 'Ein Update ist verfügbar!',
      message: 'Nach dem Bestätigen werden die neuen Inhalte geladen.',
      type: 'prompt',
      callback: () => {
        window.location.reload();
      }
    });
  }
}
